import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-[#0F1224] flex flex-col" data-testid="terms-page">
      {/* Header */}
      <header className="p-4 sm:p-6 flex items-center justify-between">
        <Link to="/" className="inline-flex items-center gap-2">
          <img src="/logo-64.png" alt="Payday Control" className="w-10 h-10 rounded-xl" />
          <span className="font-heading font-bold text-lg text-white">Payday Control</span>
        </Link>
        <Link 
          to="/" 
          className="inline-flex items-center gap-1 text-[#9CA3AF] hover:text-white transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          <span className="text-sm">Back</span>
        </Link>
      </header>

      {/* Main Content */}
      <main className="flex-1 px-4 py-8 max-w-3xl mx-auto w-full">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="space-y-8"
        >
          <div>
            <h1 className="font-heading text-2xl sm:text-3xl font-bold text-white mb-2">
              Terms of Service
            </h1>
            <p className="text-[#6B7280] text-sm">Payday Control</p>
          </div>

          <div className="prose prose-invert max-w-none space-y-6">
            <p className="text-[#9CA3AF]">
              <strong className="text-white">Effective Date:</strong> December 2025
            </p>

            <p className="text-[#9CA3AF]">
              By creating an account or using Payday Control, you agree to the following terms.
            </p>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-white">Service Description</h2>
              <p className="text-[#9CA3AF]">
                Payday Control is a financial planning tool designed to help users estimate how much money they can safely spend between paydays based on the financial information they provide.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-white">No Financial Advice</h2>
              <p className="text-[#9CA3AF]">
                Payday Control is not a bank, financial institution, or financial advisor.
              </p>
              <p className="text-[#9CA3AF]">
                The information provided by the application is for informational purposes only and should not be considered financial advice.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-white">User Responsibility</h2>
              <p className="text-[#9CA3AF]">
                Users are responsible for the accuracy of the financial information they enter into the application.
              </p>
              <p className="text-[#9CA3AF]">
                Payday Control is not responsible for financial decisions made based on the calculations shown in the app.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-white">Account Security</h2>
              <p className="text-[#9CA3AF]">
                Users are responsible for maintaining the security of their account credentials and should not share their login details.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-white">Service Availability</h2>
              <p className="text-[#9CA3AF]">
                Payday Control may update, modify, or temporarily suspend the service at any time to improve functionality or perform maintenance.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-white">Account Termination</h2>
              <p className="text-[#9CA3AF]">
                Accounts that violate the terms of service or abuse the platform may be suspended or removed.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-white">Limitation of Liability</h2>
              <p className="text-[#9CA3AF]">
                Payday Control is provided "as is" without warranties of any kind.
              </p>
              <p className="text-[#9CA3AF]">
                The service is intended as a budgeting aid and should not be relied upon as the sole basis for financial decisions.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-white">Contact</h2>
              <p className="text-[#9CA3AF]">
                For questions regarding these terms please contact:
              </p>
              <p>
                <a 
                  href="mailto:support@paydaycontrol.app" 
                  className="text-[#63E6E2] hover:underline"
                >
                  support@paydaycontrol.app
                </a>
              </p>
            </section>
          </div>
        </motion.div>
      </main>

      {/* Footer */}
      <footer className="p-4 sm:p-6 border-t border-[#2D3354]">
        <div className="flex items-center justify-center gap-4 text-sm text-[#6B7280]">
          <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
          <span>|</span>
          <Link to="/terms" className="text-[#63E6E2]">Terms of Service</Link>
          <span>|</span>
          <a href="mailto:support@paydaycontrol.app" className="hover:text-white transition-colors">Contact</a>
        </div>
      </footer>
    </div>
  );
}
